import React, {Component} from 'react';

class FilterCheckbox extends Component {
  render() {
    let {fieldName, filter} = this.props;
    let tooltip = null;
    if (filter.image) {
      tooltip = (<div className="tooltip">
        <span className="tooltip__content" dangerouslySetInnerHTML={{__html: filter.image}}></span>
      </div>);
    }

    return (
      <div className="js-form-item form-item js-form-type-checkbox">
        <input id={fieldName + "_" + filter.id}  type="checkbox" name={fieldName + "[]"} onChange={() => this.props.onFilter({name: fieldName, value: filter.id, label:filter.name})} checked={this.props.form[fieldName].indexOf(filter.id) !== -1} className="form-radio" />
        <label htmlFor={fieldName + "_" + filter.id} className="option">{filter.name}</label>
        {tooltip}
      </div>
    );
  }
}

export default FilterCheckbox;
